/**
 *
 * Asynchronously loads the component for OnboardingUsernamePage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const OnboardingUsernamePage = lazyLoad(
  () => import('./index'),
  module => module.OnboardingUsernamePage,
);
